import React, { useEffect, useState } from "react";
import {
  Box,
  CssBaseline,
  Paper,
  Typography,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  ButtonGroup,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
import api from "../../api/axiosInstance"
import AppBarComponent from "../../components/layout/AppbarComponent";
import { ToastContainer, toast } from "react-toastify";
import { useConfirm } from "../../utils/useConfirm";

const AddUsecase = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL;
  const { confirm } = useConfirm();
  //use object because it have only software
  const [softwareData, setSoftwareData] = useState({});

  //use array because it have multiple item
  const [fetchData, setFetchData] = useState([]);
  const [usecases, setUsecases] = useState([]);

  // Fetch software data
  useEffect(() => {
    const fetchSoftware = async () => {
      try {
        const res = await api.get(`api/software/getsoftware/${id}`);
        setSoftwareData(res.data);
      } catch (err) {
        console.error("Error fetching software details", err);
      }
    };

    const fetchUsecases = async () => {
      try {
        const res = await api.get(`api/usecase/getusecases/${id}`);
        if (res.data && res.data.length > 0) {
          setFetchData(res.data);
          setUsecases(res.data);
        }
      } catch (err) {
        console.error("Error fetching use cases", err);
      }
    };

    fetchUsecases();
    fetchSoftware();
  }, [id, API_URL]);

  const handleChange = (index, e) => {
    const { name, value } = e.target;

    const newList = usecases.map((uc, i) =>
      i === index ? { ...uc, [name]: value } : uc
    );

    setUsecases(newList);
  };

  const addRow = () => {
    setUsecases([
      ...usecases,
      { usecase_id: null, usecase_name: "", description: "", actor: "" },
    ]);
  };

  const handleSave = async () => {
    try {
      const res = await api.post(`api/usecase/addusecase`, {
        software_id: id,
        usecases,
      });
      setFetchData(usecases);
      toast.success(res.data.message);
    } catch (err) {
      console.error(err);
      if (err.response && err.response.data) {
        toast.error("Error: " + err.response.data.message);
      } else {
        toast.error("เกิดข้อผิดพลาด ไม่สามารถบันทึกได้");
      }
    }
  };

  const handleBack = async () => {
    const hasChanges = JSON.stringify(fetchData) !== JSON.stringify(usecases);
    if (hasChanges) {
      const ok = await confirm(
        "คุณยังไม่ได้บันทึกการเปลี่ยนแปลง ต้องการดำเนินการต่อหรือไม่?"
      );
      if (!ok) return;
    }
    navigate(`/software/edit/${id}`);
  };

  const handleNext = async () => {
    const hasChanges = JSON.stringify(fetchData) !== JSON.stringify(usecases);
    if (hasChanges) {
      const ok = await confirm(
        "คุณยังไม่ได้บันทึกการเปลี่ยนแปลง ต้องการดำเนินการต่อหรือไม่?"
      );
      if (!ok) return;
    }
    navigate(`/software/addfunction/${id}`);
  };

  const handleDeleteRow = async (index, item) => {
    // ถ้ามี id แสดงว่าเป็น use case เดิม ต้องลบจาก DB
    if (item.usecase_id) {
      try {
        const ok = await confirm(
          "Usecase นี้ ถูกบันทึกในฐานข้อมูลแล้ว คุณต้องการจะลบใช่หรือไม่?"
        );
        if (!ok) return;
        const res = await api.delete(
          `api/usecase/delusecase/${item.usecase_id}`
        );
        toast.success(res.data.message);
      } catch (err) {
        toast.error("ลบจากฐานข้อมูลไม่สำเร็จ");
        return;
      }
    }

    // ลบจาก state
    const newList = [...usecases];
    newList.splice(index, 1);
    setUsecases(newList);
    setFetchData(newList);
  };

  return (
    <>
      <CssBaseline />
      <AppBarComponent />
      <ToastContainer position="top-center" autoClose={2000} />
      <Box sx={{ p: 2, backgroundColor: "#DFF6F0", minHeight: "100vh" }}>
        <Paper
          sx={{
            width: "95%",
            m: "0 auto",
            p: 3,
            borderRadius: 2.5,
            backgroundColor: "#E6F7F4",
          }}
        >
          <Typography variant="h5" mb={2} sx={{ fontWeight: "bold" }}>
            เพิ่ม Use Case สำหรับโครงการ :
          </Typography>
          <Typography variant="h5" mb={2} sx={{ fontWeight: "bold" }}>
            {id}{"_"}
            {softwareData.software_name ? softwareData.software_name : ""}
          </Typography>

          <TableContainer component={Paper} sx={{ mb: 3 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>Use Case</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>คำอธิบาย</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    ผู้ใช้งาน (Actor)
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {usecases.map((uc, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <TextField
                        fullWidth
                        name="usecase_name"
                        value={uc.usecase_name}
                        onChange={(e) => handleChange(index, e)}
                      />
                    </TableCell>

                    <TableCell>
                      <TextField
                        fullWidth
                        name="description"
                        value={uc.description}
                        onChange={(e) => handleChange(index, e)}
                      />
                    </TableCell>

                    <TableCell>
                      <TextField
                        fullWidth
                        name="actor"
                        value={uc.actor}
                        onChange={(e) => handleChange(index, e)}
                      />
                    </TableCell>

                    <TableCell>
                      <Button
                        variant="outlined"
                        color="error"
                        onClick={() => handleDeleteRow(index, uc)}
                      >
                        ลบ
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Button
            variant="contained"
            color="info"
            onClick={addRow}
            sx={{ fontWeight: "bold", mb: 2 }}
          >
            + เพิ่ม Use Case
          </Button>

          <Button
            variant="contained"
            color="info"
            onClick={() => toast.info("อยู่ระหว่างการพัฒนา")}
            sx={{ fontWeight: "bold", mb: 2, ml: 2 }}
          >
            อัปโหลดเอกสาร Use Case
          </Button>

          <Box display="flex" justifyContent="space-between">
            <Button
              variant="contained"
              color="success"
              onClick={handleSave}
              sx={{ fontWeight: "bold" }}
            >
              บันทึก
            </Button>

            <ButtonGroup>
              <Button
                variant="contained"
                color="inherit"
                onClick={handleBack}
                sx={{ fontWeight: "bold" }}
              >
                ย้อนกลับ
              </Button>

              <Button
                variant="contained"
                color="primary"
                onClick={handleNext}
                sx={{ fontWeight: "bold" }}
              >
                ถัดไป
              </Button>
            </ButtonGroup>
          </Box>
        </Paper>
      </Box>
    </>
  );
};

export default AddUsecase;
